// extracted by mini-css-extract-plugin
export default {"SuggestionsStrip":"SuggestionsStrip_SuggestionsStrip__wFsWQ","SuggestionPill":"SuggestionsStrip_SuggestionPill__sLPh7"};